import store from '@/store';

export default {
  show(name) {
    store.dispatch('gloading/show', name);
  },
  hide(name) {
    store.dispatch('gloading/hide', name);
  },
  stop() {
    store.dispatch('gloading/stop');
  },
  isLoading(names) {
    return store.getters['gloading/isLoading'](names);
  }
};
